import script from "./PatientCasePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientCasePicker.vue?vue&type=script&setup=true&lang=ts"

import "./PatientCasePicker.vue?vue&type=style&index=0&id=1eb25598&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb25598"]])

export default __exports__